module.exports = __webpack_public_path__ + "img/empty-profile-graphic.b074dd06.svg";